import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UiCheckmarkComponent } from './components/ui-checkmark/ui-checkmark.component'
import { UiCardComponent } from './components/ui-card/ui-card.component'
import { UiButtonComponent } from './components/ui-button/ui-button.component'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { RouterModule } from '@angular/router'
import { MenuIconComponent } from './components/menu-icon/menu-icon.component'
import { SocialMediaLinksComponent } from './components/social-media-links/social-media-links.component'
import { ActionBoxComponent } from './components/action-box/action-box.component'
import { LocalizedUrlPipe } from './pipes/localized_url.pipe'
import { SectionComponent } from './components/section/section.component'
import { HeroComponent } from './components/hero/hero.component'
import { SummaryCardComponent } from './components/summary-card/summary-card.component'
import { FooterComponent } from './components/footer/footer.component'
import { MarkdownPipe } from './pipes/markdown.pipe'
import { VisualGreatFailureComponent } from './components/visual-great-failure/visual-great-failure.component'
import { LogoComponent } from './components/visual-logo/logo.component'
import { VisualGreatSuccessComponent } from './components/visual-great-success/visual-great-success.component'
import { UiTimedloaderComponent } from './components/ui-timedloader/ui-timedloader.component'
import { LoginSubmitComponent } from './components/login-submit/login-submit.component'
import { EmailInputComponent } from './components/email-input/email-input.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SummaryCardColumnComponent } from './components/summary-card-column/summary-card-column.component'
import { SummaryCardWrapperComponent } from './components/summary-card-wrapper/summary-card-wrapper.component'
import { UiStepperComponent } from './components/ui-stepper/ui-stepper.component'
import { UiStepperStepComponent } from './components/ui-stepper-step/ui-stepper-step.component'
import { ListUspComponent } from './components/list-usp/list-usp.component'
import { WrapperComponent } from './components/wrapper/wrapper.component'
import { PdfobjectComponent } from './components/pdfobject/pdfobject.component'
import { UiRoundedEmailInputComponent } from './components/ui-rounded-email-input/ui-rounded-email-input.component'
import { UiRoundedInputComponent } from './components/ui-rounded-input/ui-rounded-input.component'
import { UiEmailStandaloneInputComponent } from './components/ui-email-standalone-input/ui-email-standalone-input.component'
import { SafeHtmlPipe } from './pipes/safeHtml.pipe'
import { UiLoadingContainerComponent } from './components/ui-loading-container/ui-loading-container.component'
import { MyMisterGreenIconComponent } from '../monolith/components/my-mistergreen-icon/my-mistergreen-icon.component'

import { QueryParamsExtractPipe, QueryParamsRemovePipe } from './pipes/queryParams.pipe'
import { DIRECTIVES } from './directives'
import { ErrorService } from './services/error.service'
import { FormHelperService } from './services/form-helper.service'
import { InlineSVGModule } from 'ng-inline-svg'
import { LoggedDialogComponent } from './components/login-submit/logged-dialog/logged-dialog.component'
import { UiAnimatedCheckDotComponent } from './components/ui-animated-check-dot/ui-animated-check-dot.component'
import { LightingLogoComponent } from './components/lighting-logo/lighting-logo.component'
import { UiModalComponent } from './components/ui-modal/ui-modal.component'
import { DialogComponent } from './components/ui-modal/dialog'
import { MatDialogModule } from '@angular/material/dialog'
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component'
import { HeaderComponent } from './components/header/header.component'
import { AddressComponent } from './components/address/address.component'
import { IdealIconComponent } from './components/ideal-icon/ideal-icon.component'
import { FileInputComponent } from './components/file-input/file-input.component'

export const COMPONENTS = [
    UiCheckmarkComponent,
    UiCardComponent,
    UiButtonComponent,
    UiTimedloaderComponent,
    UiLoadingContainerComponent,
    UiStepperComponent,
    UiStepperStepComponent,
    ActionBoxComponent,
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    MenuIconComponent,
    SocialMediaLinksComponent,
    PdfobjectComponent,
    SectionComponent,
    SummaryCardComponent,
    SummaryCardColumnComponent,
    SummaryCardWrapperComponent,
    LocalizedUrlPipe,
    QueryParamsRemovePipe,
    QueryParamsExtractPipe,
    MarkdownPipe,
    SafeHtmlPipe,
    VisualGreatFailureComponent,
    VisualGreatSuccessComponent,
    LogoComponent,
    LoginSubmitComponent,
    EmailInputComponent,
    UiRoundedEmailInputComponent,
    UiRoundedInputComponent,
    UiEmailStandaloneInputComponent,
    LoggedDialogComponent,
    UiAnimatedCheckDotComponent,
    LightingLogoComponent,
    UiModalComponent,
    DialogComponent,
    ListUspComponent,
    WrapperComponent,
    ProgressBarComponent,
    AddressComponent,
    MyMisterGreenIconComponent,
    IdealIconComponent,
    FileInputComponent,
]

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatFormFieldModule,
        MatMenuModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        InlineSVGModule.forRoot(),
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
    ],
    declarations: [...COMPONENTS, ...DIRECTIVES],
    exports: [...COMPONENTS, ...DIRECTIVES],
    providers: [ErrorService, FormHelperService],
})
export class UiModule {}
